if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton =
          this.querySelector('[type="submit"][name="add"]') ||
          this.form.querySelector('[type="submit"][name="add"]') ||
          this.querySelector('[type="submit"]') ||
          this.form.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      getFdoPersonalizationFeeQuantity(formData) {
        const customizerType = String(formData.get('properties[Customizer type]') || '').toLowerCase();
        if (!customizerType.includes('pet creation studio')) return 0;

        const frontStyle = String(formData.get('properties[Front creation style]') || '').trim();
        if (!frontStyle || frontStyle === 'Blank / no engraving') return 0;

        let quantity = 1;
        const backStyle = String(formData.get('properties[Back creation style]') || '').trim();
        if (backStyle && backStyle !== 'Blank / no engraving') quantity += 1;

        return quantity;
      }

      async addFdoPersonalizationFee(formData) {
        const feeQuantity = this.getFdoPersonalizationFeeQuantity(formData);
        if (!feeQuantity) return null;

        const feeVariantId = 53170853249321;
        const cartAddUrl = routes.cart_add_url.endsWith('.js') ? routes.cart_add_url : `${routes.cart_add_url}.js`;
        const sectionIds = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : [];

        const response = await fetch(cartAddUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            items: [
              {
                id: feeVariantId,
                quantity: feeQuantity,
                properties: {
                  _fdo_fee: 'Personalization side fee',
                  _fdo_fee_for_variant: String(formData.get('id') || ''),
                  _fdo_fee_sides: feeQuantity === 1 ? '1 side' : '2 sides',
                },
              },
            ],
            sections: sectionIds,
            sections_url: window.location.pathname,
          }),
        });

        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Personalization fee could not be added.');
        }
        return data;
      }

      onSubmitHandler(evt) {
        evt.preventDefault();

        this.cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        this.submitButton =
          this.submitButton ||
          evt.submitter ||
          this.querySelector('[type="submit"][name="add"]') ||
          this.form.querySelector('[type="submit"][name="add"]') ||
          this.querySelector('[type="submit"]') ||
          this.form.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButtonText || (this.submitButton ? this.submitButton.querySelector('span') : null);

        if (!this.submitButton) {
          this.form.submit();
          return;
        }

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const spinner = this.querySelector('.loading__spinner') || this.form.querySelector('.loading__spinner');
        if (spinner) spinner.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              if (this.submitButtonText) this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            let renderResponse = response;
            try {
              const feeResponse = await this.addFdoPersonalizationFee(formData);
              if (feeResponse) renderResponse = feeResponse;
            } catch (feeError) {
              console.error(feeError);
              this.handleErrorMessage('The product was added, but the personalization fee could not be added. Please remove it and try again.');
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: renderResponse,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(renderResponse);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(renderResponse);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.handleErrorMessage('We could not add this product to the cart. Please try again.');
          })
          .finally(() => {
            if (this.submitButton) {
              this.submitButton.classList.remove('loading');
              if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            }
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            const spinner = this.querySelector('.loading__spinner') || this.form.querySelector('.loading__spinner');
            if (spinner) spinner.classList.add('hidden');

            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        this.submitButton =
          this.submitButton ||
          this.querySelector('[type="submit"][name="add"]') ||
          this.form.querySelector('[type="submit"][name="add"]') ||
          this.querySelector('[type="submit"]') ||
          this.form.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButtonText || (this.submitButton ? this.submitButton.querySelector('span') : null);
        if (!this.submitButton) return;

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text && this.submitButtonText) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          if (this.submitButtonText) this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form ? this.form.querySelector('[name=id]') : null;
      }
    }
  );
}
